// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper__8bNTI","breadCrumb":"Breadcrumbs_breadCrumb__rPxG_"};